module.exports = __webpack_public_path__ + "static/media/empty.abd23a49.svg";